import type { ExternalHref } from "@qendo/util";
import type { Href } from "expo-router";
import * as WebBrowser from "expo-web-browser";

export function isExternalLink(link?: Href | ExternalHref | string | null): link is ExternalHref {
    return typeof link === "string" && /^https?:\/\//.test(link);
}

export async function openLink(link: ExternalHref) {
    await WebBrowser.openBrowserAsync(link);
}
